import { AxiosInstance } from 'axios'
import { CustomBlockContent, MediaObject } from '../types'

export interface ServicesPageBlockDto {
  data: {
    id: number
    attributes: ServicePageBlock
  }
}

interface ServicePageBlock {
  conclusion_text?: CustomBlockContent | string
  conclusion_title?: string
  wa_text?: CustomBlockContent | string

  an_introduction_to_title?: string
  in_a_step_by_step_title?: string
  how_the_procedure_works_title?: string
  results_title?: string
  what_do_you_get_as_a_result_title?: string
  special_offers_title?: string
  specialists_title?: string
  price_list_title?: string
  price_list_service_title?: string
  price_list_price_title?: string
  additional_services_title?: string
  our_equipment_title?: string
  questions_and_answers_title?: string

  send_button_text?: string
  book_now_button_text?: string
  empty_price_text?: string

  conclusion_image?: MediaObject
}

export type GetServicesPageBlockArgs = {
  locale: string
}

export const getServicesPageBlock = async (client: AxiosInstance, { locale }: GetServicesPageBlockArgs) => {
  const path = `/service-page-block`
  const params = {
    locale,
    populate: {
      conclusion_image: {
        populate: '*',
      },
    },
  }
  return (await client.get<ServicesPageBlockDto>(path, { params })).data.data.attributes
}
